import React from 'react'
import Nav from '../Components/Outlets/Nav'
import Footer from '../Components/Outlets/Footer'
import footbox from '../Assets/footer-box.svg'

const Contact = () => {
	return (
		<div>
			<Nav />
			<div class="about-page-main">
				<div className="path-menus contact-page">
					<div className="container-main">
						<h2 class="page-heading-name mb-0">Contact Us</h2>
					</div>
				</div>
			</div>
			<div className="contact-page-dv">
				<div className="container-main">
					<div className="row">
						<div className="col-lg-6">
							<div className="contact-dv">
								<h2 className='feel-text'>Feel Free To Contact And <br /> Reach Us !</h2>
								<div className="footer-image">
									<img src={footbox} className='img-foot' alt="" />
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="footer-dv">
								<form>
									<div className="row">
										<div className="col-lg-6">
											<div class="form-group">
												<input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Name" />
											</div>
										</div>
										<div className="col-lg-6">
											<div class="form-group">
												<input type="password" class="form-control" id="exampleInputPassword1" placeholder="Enter phone number" />
											</div>
										</div>
										<div className="col-lg-6">
											<div class="form-group">
												<input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your  email" />
											</div>
										</div>
										<div className="col-lg-6">
											<div class="form-group">
												<input type="password" class="form-control" id="exampleInputPassword1" placeholder="Enter your Place" />
											</div>
										</div>
										<div className="col-lg-12">
										<div class="form-group">
											<textarea class="form-control" placeholder='Your Message' id="exampleFormControlTextarea1" rows="4"></textarea>
										</div>
										</div>
									</div>
									<button type="submit" class="btn btn-submit">Submit</button>
								</form>
							</div>
						</div>

						<div className="col-lg-12">
							<div className="map-main">
							<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7814.915433292665!2d75.73928877711298!3d11.66193881082251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba67e5a169a7bb7%3A0x8d6e0e78fb9b24e3!2sSirajul%20Huda%20English%20Medium%20School!5e0!3m2!1sen!2sin!4v1738305122696!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>















			<Footer />
		</div>
	)
}

export default Contact